import {
  PURCHASE_ORDER_IMPORT_PAST_DELIVERY_FILTER,
  PURCHASE_ORDER_IMPORT_PAST_DELIVERY_LABEL,
  PURCHASE_ORDER_IMPORT_ROW_RESULT_LABEL,
  PurchaseOrderChain,
  PurchaseOrderImportRowResult,
} from "../../types/purchase-order.type";

/**
 * ค่าคงที่ของจอ W2 "นำเข้าไฟล์ PO" — รวมไว้ที่เดียวเพราะถูกใช้ทั้งในการ์ดเลือกไฟล์
 * ตารางตัวอย่าง และแถวในตาราง
 */

/**
 * นามสกุล + mime ที่ backend รับ (PurchaseOrderImportFile: .xlsx/.xls, 10MB, 1 ไฟล์)
 * ไม่รับ .xlsm/.csv เหมือนกับที่ fileFilter ฝั่ง server ปฏิเสธด้วย 415
 */
export const ACCEPTED_FILE_TYPES =
  ".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel";

/** ทุกเชนที่ระบบรู้จัก แสดงครบเพื่อให้เห็นว่าช่องนี้จะมีตัวเลือกอื่นในอนาคต */
export const CHAIN_OPTIONS: readonly PurchaseOrderChain[] = ["BIGC", "LOTUS"];

/**
 * เชนที่นำเข้าได้จริงในเฟสนี้ — parser แยกตามเชน และ backend ปฏิเสธเชนที่ยังไม่มี
 * parser ด้วย 422 ตัวเลือกที่เหลือจึงแสดงไว้แต่กดไม่ได้ ดีกว่าปล่อยให้อัปแล้วเจอ error
 */
export const IMPORTABLE_CHAINS: readonly PurchaseOrderChain[] = ["BIGC"];

export const DEFAULT_CHAIN: PurchaseOrderChain = "BIGC";

/** ผลตรวจเดียวที่ต้องให้คนเลือกสาขา · ปล่อยว่างได้ บันทึกเป็น ยังไม่ระบุสาขา */
export const BRANCH_REQUIRED_RESULT: PurchaseOrderImportRowResult =
  "BRANCH_REQUIRED";

/** แถวที่ซ้ำกับ PO ที่มีอยู่ — ไม่ถูกบันทึกเสมอ */
export const DUPLICATE_RESULT: PurchaseOrderImportRowResult = "DUPLICATE";

/** ผลตรวจที่ระบบจับคู่ร้านได้เอง — แถวพวกนี้ห้ามส่ง branch_choices (backend ตอบ 422) */
export const MATCHED_RESULT: PurchaseOrderImportRowResult = "MATCHED";

/** ตัวเลือกของตัวกรอง "ผลตรวจ" เรียงตามลำดับที่ผู้ใช้ต้องจัดการก่อนหลัง */
export const ROW_RESULT_FILTER_OPTIONS: readonly PurchaseOrderImportRowResult[] =
  ["BRANCH_REQUIRED", "MATCHED", "DUPLICATE"];

/** ตัวเลือกทั้งหมดของตัวกรองแถว — ผลตรวจสามค่า + หมวด เกินกำหนดส่ง ของจอเอง */
export const ROW_FILTER_OPTIONS: readonly (
  | PurchaseOrderImportRowResult
  | typeof PURCHASE_ORDER_IMPORT_PAST_DELIVERY_FILTER
)[] = [...ROW_RESULT_FILTER_OPTIONS, PURCHASE_ORDER_IMPORT_PAST_DELIVERY_FILTER];

export const ROW_FILTER_LABEL: Record<(typeof ROW_FILTER_OPTIONS)[number], string> = {
  ...PURCHASE_ORDER_IMPORT_ROW_RESULT_LABEL,
  [PURCHASE_ORDER_IMPORT_PAST_DELIVERY_FILTER]:
    PURCHASE_ORDER_IMPORT_PAST_DELIVERY_LABEL,
};

export const ROW_RESULT_CHIP_COLOR: Record<
  PurchaseOrderImportRowResult,
  "success" | "warning" | "default"
> = {
  MATCHED: "success",
  BRANCH_REQUIRED: "warning",
  DUPLICATE: "default",
};

/** ธีมใส่ padding + เงาให้ Paper ทุกใบอยู่แล้ว การ์ดในจอนี้จึงคุมเองทั้งคู่ */
export const CARD_SX = { boxShadow: "none", borderRadius: "12px" } as const;
export const CARD_CONTENT_SX = { p: 2, "&:last-child": { pb: 2 } } as const;
